import Container from '@mui/material/Container';
import Page from '../components/Page';
import { Loader } from 'src/components';
import LogoLoader from 'src/components/LogoLoader';
import Iconify from 'src/components/Iconify';
import { Stack } from '@mui/material';
import LogoLoader2 from 'src/components/LogoLoader2';

const FAQ = () => (
  <Page title="Frequently asked question">
    <Container>
      <Stack direction="column" spacing={1}>
        <Loader />
        <Loader
          icon={<Iconify icon="material-symbols:lock" color="#87c8e0" width={24} height={24} />}
        />
        <LogoLoader />
        <LogoLoader2
          icon={<Iconify icon="material-symbols:lock" color="#87c8e0" width={24} height={24} />}
        />
        <Stack direction="row" spacing={1} justifyContent="center">
          <LogoLoader2 size={40} />
          <LogoLoader2 size={75} />
          <LogoLoader2 size={150} />
        </Stack>
      </Stack>
    </Container>
  </Page>
);

export default FAQ;
